import type { FormEvent } from 'react';

interface Props {
  email: string;
  code: string;
  loading: boolean;
  onCodeChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchView: (view: 'login') => void;
}

export default function VerifyForm({
  email,
  code,
  loading,
  onCodeChange,
  onSubmit,
  onSwitchView,
}: Props) {
  return (
    <form onSubmit={onSubmit} className="auth-form">
      <div>
        <h2>Verify email</h2>
        <p className="auth-subtitle">Enter the code sent to {email}</p>
      </div>
      <div className="field">
        <label className="field-label" htmlFor="verify-code">
          Verification code
        </label>
        <input
          id="verify-code"
          className="input"
          type="text"
          value={code}
          onChange={(e) => onCodeChange(e.target.value)}
          required
          autoComplete="one-time-code"
          placeholder="123456"
        />
      </div>
      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? 'Verifying...' : 'Verify'}
      </button>
      <div className="auth-links">
        <button type="button" className="link-btn" onClick={() => onSwitchView('login')}>
          Back to sign in
        </button>
      </div>
    </form>
  );
}
